export class User {
  username: string;
  email: string;
  roles: string[];

  constructor(username: string, email: string, roles: string[]) {
    this.username = username;
    this.email = email;
    this.roles = roles;
  }
}
